import ReactOnRails from 'react-on-rails';

import Store from '../store';

export const registerComponents = (registrations: Record<string, React.ElementType>) => {
  ReactOnRails.registerStore({ appStore: Store });
  ReactOnRails.register(registrations);
};
